import api from './api';

export const authService = {
  login: (data) => api.post('/auth/login', data).then((r) => r.data),
  me: () => api.get('/auth/me').then((r) => r.data),
  updateProfile: (data) => api.put('/auth/profile', data).then((r) => r.data),
  changePassword: (data) => api.put('/auth/change-password', data).then((r) => r.data),
  forgotPassword: (data) => api.post('/auth/forgot-password', data).then((r) => r.data),
  resetPassword: (token, data) => api.post(`/auth/reset-password/${token}`, data).then((r) => r.data),
  register: (data) => api.post('/auth/register', data).then((r) => r.data),
};
